import { keyframes } from 'styled-components';

export const stickyAnimation = keyframes`
	100% { transform: translateY(0); }
`;

export const openSidebarMenu = keyframes`
	0% { transform: translateX(100%); }
	100% { transform: translateX(0); }
`;

export const closeSidebarMenu = keyframes`
	0% { transform: translateX(0); }
	100% { transform: translateX(100%); }
`;

export const showPage = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

export const submenuMobileOpen = keyframes`
	0% { max-height: 0; }
	100% { max-height: 400px; }
`;

export const submenuMobileClose = keyframes`
	0% { max-height: 400px; }
	100% { max-height: 0; }
`;
